/**
 * Application-wide constants (non-sensitive).
 */
export const APP = {
  name: 'MasterHub',
  shortName: 'MasterHub',
  locale: 'pt-BR',
  currency: 'BRL',
} as const

export const PAGINATION = {
  defaultPageSize: 20,
  pageSizeOptions: [10, 20, 50, 100],
} as const

export const STORAGE_KEYS = {
  theme: 'masterhub-theme',
  sidebar: 'masterhub-sidebar',
  priceStore: 'masterhub-price-store',
  quoteDraft: 'masterhub-quote-draft',
  searchStore: 'masterhub-search-store',
} as const
